import React, { useState } from "react";
import { ROUTES } from "./constants";
import QuoteManagement from "./QuoteManagement";

export default function Index() {
  const [page, setPage] = useState(ROUTES.DETAILS);

  switch (page) {
    case ROUTES.DETAILS:
      return <QuoteManagement setPage={setPage} />;

    default:
      return <QuoteManagement setPage={setPage} />;
  }
}
